export default function (defaultValue = false) {
  return {
    editable: {
      type: Boolean,
      default: defaultValue,
    },
  };
}
